import { createStore } 	from 'vuex'
import projectsStore 	from '@/plugins/lib@project/store/projects.module'

const store = createStore({
	modules: {
		projectsStore,
	}
})

export default store